import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-navigation"
export default class extends Controller {
  static targets = ["link", "bar", "inset"]

  connect() {
    const barStyle = getComputedStyle(this.barTarget)
    this.barBorderLeft = Number.parseFloat(barStyle.borderLeftWidth)
    this.barBorderRight = Number.parseFloat(barStyle.borderRightWidth)
    this.handleViewportChange = this.handleViewportChange.bind(this)
    window.addEventListener("scroll", this.handleViewportChange, { passive: true })
    window.addEventListener("resize", this.handleViewportChange)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleViewportChange)
    window.removeEventListener("resize", this.handleViewportChange)
    this.resetBar()
  }

  handleViewportChange() {
    this.refresh()
  }

  refresh() {
    this.updateBar()

    const marker = window.scrollY + 144
    const sections = this.linkTargets.filter((link) => link.getClientRects().length > 0).map((link) => {
      const section = document.getElementById(link.hash.slice(1))
      if (!section) return null

      const top = this.sectionTop(section)
      return { link, top, bottom: top + section.offsetHeight }
    }).filter(Boolean)

    const activeSection = sections.find(({ top, bottom }) => marker >= top && marker < bottom) ||
      sections.filter(({ top }) => top <= marker).at(-1)

    this.setActive(activeSection?.link)
  }

  updateBar() {
    const bounds = this.element.getBoundingClientRect()
    const stickyTop = Number.parseFloat(getComputedStyle(this.element).top)

    if (bounds.top > stickyTop) {
      this.resetBar()
      return
    }

    const viewportWidth = document.documentElement.clientWidth
    this.barTarget.style.width = `${viewportWidth}px`
    this.barTarget.style.marginLeft = `${-bounds.left}px`
    this.barTarget.style.borderRadius = "0"
    this.barTarget.style.borderWidth = "0"
    this.insetTarget.style.paddingLeft = `${bounds.left + this.barBorderLeft}px`
    this.insetTarget.style.paddingRight = `${viewportWidth - bounds.right + this.barBorderRight}px`
  }

  resetBar() {
    this.barTarget.style.width = ""
    this.barTarget.style.marginLeft = ""
    this.barTarget.style.borderRadius = ""
    this.barTarget.style.borderWidth = ""
    this.insetTarget.style.paddingLeft = ""
    this.insetTarget.style.paddingRight = ""
  }

  sectionTop(section) {
    if (section.id === "overview") {
      const listingGrid = section.closest("aside")?.parentElement
      if (listingGrid) return listingGrid.getBoundingClientRect().top + window.scrollY
    }

    return section.getBoundingClientRect().top + window.scrollY
  }

  setActive(activeLink) {
    if (this.activeLink === activeLink) return

    this.linkTargets.forEach((link) => {
      const active = link === activeLink
      link.classList.toggle("bg-cw-purple-700", active)
      link.classList.toggle("text-white", active)
      link.classList.toggle("hover:bg-cw-purple-800", active)
      link.classList.toggle("text-blue-600", !active)
      link.classList.toggle("hover:bg-stone-100", !active)

      if (active) {
        link.setAttribute("aria-current", "location")
      } else {
        link.removeAttribute("aria-current")
      }
    })

    this.activeLink = activeLink
    activeLink?.scrollIntoView({ block: "nearest", inline: "nearest" })
  }
}
